var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { PORTAL_STATUS } from '../../components/ModuleHeader/ModuleHeader';
import ModuleTable from '../../components/UtilityComponents/moduleTable';
import AutoCompleteDD from '../../components/FormComponents/AutoCompleteDD';
import SearchField from '../../components/FormComponents/SearchField';
import { UserMangementCols } from '../../config/TableColumns';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import moment from 'moment';
import constants from '../../config/constants';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import UserModuleDrawer from './UserModuleDrawer';
import { utility } from '../../utils';
import { useSelector } from 'react-redux';
var freezedUserList = [];
var UserManagement = function () {
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var userManagementPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'USER_MANAGMENT'; });
    var canView = (userManagementPermission === null || userManagementPermission === void 0 ? void 0 : userManagementPermission.View) === 1;
    var canAdd = (userManagementPermission === null || userManagementPermission === void 0 ? void 0 : userManagementPermission.Add) === 1;
    var canUpdate = (userManagementPermission === null || userManagementPermission === void 0 ? void 0 : userManagementPermission.Update) === 1;
    var canDelete = (userManagementPermission === null || userManagementPermission === void 0 ? void 0 : userManagementPermission.Delete) === 1;
    var _a = useState(null), selectedPortal = _a[0], setSelectedPortal = _a[1];
    var _b = useState(), selectedStatus = _b[0], setSelectedStatus = _b[1];
    var _c = useState(), searchText = _c[0], setSearchText = _c[1];
    var _d = useState(undefined), vendorList = _d[0], setVendorList = _d[1];
    var _e = useState([]), dealerList = _e[0], setDealerListToDisplay = _e[1];
    var _f = useState(false), isFetching = _f[0], setIsFetching = _f[1];
    var _g = useState(false), openSuccess = _g[0], setOpenSuccess = _g[1];
    var _h = useState(''), msgText = _h[0], setMsgText = _h[1];
    var _j = useState(), rowData = _j[0], setRowData = _j[1];
    var _k = useState(false), open = _k[0], setOpen = _k[1];
    var getDealerListBasedOnVendor = function () {
        setIsFetching(true);
        setDealerListToDisplay([]);
        freezedUserList = [];
        api_service.get({
            endPoint: api_urls.DEALER_LIST,
            payLoad: { PortalId: selectedPortal }
        }).then(function (res) {
            setIsFetching(false);
            setSelectedStatus(PORTAL_STATUS[0].code);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var dealerList_1 = res.data.data;
                dealerList_1.map(function (eachDealer, index) {
                    eachDealer.CreatedTime = moment(eachDealer.CreatedTime).tz('America/New_York');
                    if (eachDealer.Status === 0) {
                        eachDealer.userStatus = "Deactivated";
                    }
                    else if (eachDealer.userStatus = eachDealer.RoleType == 'CUSTOMER') {
                        eachDealer.userStatus = "Active";
                    }
                    else {
                        eachDealer.userStatus = eachDealer.RoleType !== 'VENDSREP' ? eachDealer.RoleApproval : "Active";
                    }
                });
                freezedUserList = __spreadArray([], dealerList_1, true);
                Object.freeze(freezedUserList);
                setDealerListToDisplay(dealerList_1);
            }
        }).catch(function (err) { setIsFetching(false); });
    };
    useEffect(function () {
        api_service.get({
            endPoint: api_urls.VENDOR_LIST,
        }).then(function (res) {
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                setVendorList(res.data.data);
            }
        }).catch(function (err) { console.log('error:', err); });
    }, []);
    useEffect(function () {
        if (selectedPortal) {
            getDealerListBasedOnVendor();
        }
    }, [selectedPortal]);
    useEffect(function () {
        var filteredList = __spreadArray([], freezedUserList, true);
        if (searchText) {
            var normalizeText_1 = function (value) {
                if (value === void 0) { value = ''; }
                return value.toLocaleLowerCase().replace(/\s+/g, ' ').trim();
            };
            var normalizedSearchText_1 = normalizeText_1(searchText);
            filteredList = freezedUserList.filter(function (eachRec) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var firstName = ((_b = (_a = eachRec.FirstName) !== null && _a !== void 0 ? _a : eachRec.firstName) !== null && _b !== void 0 ? _b : '').toString().trim();
                var middleName = ((_d = (_c = eachRec.MiddleName) !== null && _c !== void 0 ? _c : eachRec.middleName) !== null && _d !== void 0 ? _d : '').toString().trim();
                var lastName = ((_h = (_g = (_f = (_e = eachRec.LastName) !== null && _e !== void 0 ? _e : eachRec.lastName) !== null && _f !== void 0 ? _f : eachRec.SurName) !== null && _g !== void 0 ? _g : eachRec.Surname) !== null && _h !== void 0 ? _h : '').toString().trim();
                var fullName = [firstName, middleName, lastName].filter(Boolean).join(' ').trim();
                var reverseFullName = [lastName, firstName, middleName].filter(Boolean).join(' ').trim();
                var otherNameKeys = [
                    eachRec.Name,
                    eachRec.FullName,
                    eachRec.DisplayName,
                    eachRec.CustomerName,
                ]
                    .map(function (value) { return (value !== null && value !== void 0 ? value : '').toString().trim(); })
                    .filter(Boolean)
                    .join(' ');
                var fullStringToMatch = [fullName, reverseFullName, otherNameKeys].filter(Boolean).join(' ');
                if (eachRec.RoleType) {
                    fullStringToMatch += " ".concat(eachRec.RoleType);
                }
                if (eachRec.Email) {
                    fullStringToMatch += " ".concat(eachRec.Email);
                }
                return normalizeText_1(fullStringToMatch).includes(normalizedSearchText_1);
            });
        }
        if ((selectedStatus !== undefined && selectedStatus !== null) && selectedStatus !== PORTAL_STATUS[0].code) {
            var filteredCopyList = __spreadArray([], filteredList, true);
            var newList = filteredCopyList.filter(function (user) {
                return user.userStatus === selectedStatus;
            });
            filteredList = newList;
        }
        setDealerListToDisplay(filteredList);
    }, [searchText, selectedStatus]);
    useEffect(function () {
        return function () {
            setDealerListToDisplay([]);
            freezedUserList = [];
        };
    }, []);
    var tableActionHandler = function (rowData, actionType) {
        if (actionType === 'impersonate') {
            api_service.get({
                endPoint: api_urls.ADMIN_IMPERSONATE,
                payLoad: {
                    SalesRepId: rowData === null || rowData === void 0 ? void 0 : rowData.Id
                },
                showLoader: true
            }).then(function (res) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (res && res.data.statusCode === 200) {
                    var vendorDomain = (_a = vendorList === null || vendorList === void 0 ? void 0 : vendorList.find(function (item) { return item.Id === selectedPortal; })) === null || _a === void 0 ? void 0 : _a.Domain;
                    var url = "".concat(vendorDomain, "/adminDashboard?token=").concat(encodeURIComponent((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.Token), "&roleType=").concat((_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.RoleType, "&roleApproval=").concat((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.RoleApproval, "&sessionStartTime=").concat((_j = (_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.SessionStartTime);
                    window.open(url, '_blank');
                }
                else {
                    utility.alert(res.data.message, constants.TOAST_TYPES.ERROR);
                }
            }).catch(function (err) {
                utility.alert(err, constants.TOAST_TYPES.ERROR);
            });
        }
        if (actionType === "Approved" || actionType === "Denied") {
            var payLoad = {
                Id: Number(rowData.Id),
                VendorId: Number(selectedPortal),
                RoleType: rowData.RoleType,
                RoleApproval: actionType === "Approved" ? 1 : 2
            };
            api_service.post({
                endPoint: api_urls.UPDATE_USER,
                payLoad: payLoad,
                showLoader: true
            }).then(function (res) {
                setOpenSuccess(true);
                if (res && res.data.statusCode === 200) {
                    var msg = actionType === "Approved" ? "User approved successfully !" : "User denied successfully !";
                    setMsgText(msg);
                    getDealerListBasedOnVendor();
                }
            }).catch(function (err) {
                setOpenSuccess(true);
            });
        }
        else if (actionType === "Deactivated") {
            var payload = {
                Id: Number(rowData.Id),
                VendorId: Number(selectedPortal),
            };
            api_service.delete({
                endPoint: api_urls.DEACTIVATE_USER,
                payLoad: payload
            }).then(function (res) {
                setOpenSuccess(true);
                if (res && res.data.statusCode === 200) {
                    setMsgText('User deactivated successfully !');
                    getDealerListBasedOnVendor();
                }
            }).catch(function (err) {
                setOpenSuccess(true);
            });
        }
    };
    var handleRowClickHandler = function (__rowData) {
        setRowData(__rowData);
        setOpen(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px' },
            React.createElement(Grid, { container: true, spacing: 2, alignItems: "center" },
                React.createElement(Grid, { item: true, xs: 12, sm: 3, md: 3.2 },
                    React.createElement(AutoCompleteDD, { options: vendorList !== null && vendorList !== void 0 ? vendorList : [], displayKey: 'Name', valueKey: 'Id', label: '', placeholder: 'SELECT PORTAL NAME', handleChange: function (e) {
                            var value = e.target.value;
                            setSelectedPortal(value);
                            setSelectedStatus(PORTAL_STATUS[0].code);
                        }, selectedValue: (vendorList === null || vendorList === void 0 ? void 0 : vendorList.find(function (v) { return v.Id === selectedPortal; })) || { Id: '', Name: '' }, name: "PortalId", handleBlur: function () { } })),
                React.createElement(Grid, { item: true, xs: 12, sm: 3, md: 2.5 },
                    React.createElement(AutoCompleteDD, { options: PORTAL_STATUS, displayKey: 'status', valueKey: 'code', label: '', placeholder: 'Status', handleChange: function (e) {
                            var value = e.target.value;
                            setSelectedStatus(value);
                        }, selectedValue: PORTAL_STATUS.find(function (item) { return item.code === selectedStatus; }) || { status: '', code: '' }, name: "StatusFilter", handleBlur: function () { }, showStartIcon: true, startIcon: React.createElement(FilterAltOutlinedIcon, null) })),
                React.createElement(Grid, { item: true, xs: 12, sm: 3, md: 3, sx: { ml: 'auto' } },
                    React.createElement(SearchField, { onSearch: function (val) { return setSearchText(val); }, placeholder: 'Search by Name/Role/Email', value: searchText || '', debounceTimer: 400 })))),
        React.createElement(Box, { className: "common-module-wrapper user-management-wrapper", sx: {
                mt: 1,
                '& .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root th': {
                    backgroundColor: '#FFFFFF',
                    color: '#1f2733',
                    fontSize: '12px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                },
                '& .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root td': {
                    fontSize: '13px',
                    padding: '10px 16px',
                },
                '& .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root p': {
                    fontSize: '13px',
                },
            } },
            React.createElement(Box, { className: "module-common-table-wrapper" },
                React.createElement(ModuleTable, { dataToDisplay: dealerList, columns: UserMangementCols, isLoading: isFetching, isRowClickEnabled: canView, onClickHandler: handleRowClickHandler, actionHandler: tableActionHandler, moduleName: "User Management", isPortalSelected: selectedPortal, tableContainerMaxHeight: 'calc(100vh - 250px)', isActionColumn: canUpdate || canDelete, canUpdate: canUpdate, hidePagination: false }))),
        React.createElement(Box, null,
            React.createElement(UserModuleDrawer, { open: open, handleClose: function () { setRowData(null); setOpen(false); }, rowData: rowData, getDealerListBasedOnVendor: getDealerListBasedOnVendor, canUpdate: canUpdate })),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: 'Success!', open: openSuccess, message: msgText, acceptBtnText: 'Ok', acceptCallBack: function () {
                setOpenSuccess(false);
                setMsgText('');
            } })));
};
export default UserManagement;
